export const categories = [
  { slug: 'mingxing-bagua', name: '明星八卦', icon: 'ri-star-line', description: '最新明星八卦、恋情曝光、私生活揭秘' },
  { slug: 'wanghong-fanche', name: '网红翻车', icon: 'ri-alert-line', description: '网红人设崩塌、直播翻车、黑历史被扒' },
  { slug: 'remen-guaqing', name: '热门瓜情', icon: 'ri-fire-line', description: '当下最火爆的娱乐爆料、热门话题追踪' },
  { slug: 'zongyi-baoliao', name: '综艺爆料', icon: 'ri-tv-line', description: '综艺节目内幕、选手争议、录制花絮' },
  { slug: 'yingshiquan', name: '影视圈', icon: 'ri-film-line', description: '影视行业动态、剧组秘闻、票房内幕' },
];

export const articles = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，两人举止亲密疑似恋情曝光',
    slug: 'dingliu-nanxing-shenye-mihui',
    category: 'mingxing-bagua',
    excerpt: '据知情人士透露，该顶流男星在结束品牌活动后并未返回酒店，而是驱车前往某高档小区，与一位神秘女子共度良宵。',
    content: `据知情人士透露，某顶流男星在上周五结束品牌活动后，并未按照行程安排返回酒店休息，而是独自驱车前往位于朝阳区的一处高档小区。

据蹲守多时的狗仔拍到，该男星在小区门口接上了一位身穿黑色连衣裙的神秘女子，两人随后一同进入小区内的一栋独栋别墅。直到第二天上午十点左右，该男星才独自驾车离开。

有网友扒出，这位神秘女子疑似某知名模特经纪公司的签约模特，两人此前曾在一场时尚活动中同台。当时就有网友发现两人眼神交流频繁，互动颇为暧昧。

对此，该男星工作室暂未作出回应。但粉丝们已经炸开了锅，有人表示"坐等官宣"，也有人表示"不信谣不传谣"。

不过吃瓜群众们普遍认为，这次爆料可信度较高——毕竟有图有真相，而且该男星近期确实频繁被拍到与该女子的同框照。`,
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20night%20scene%20with%20a%20luxury%20car%20parked%20outside%20an%20upscale%20apartment%20building%2C%20warm%20golden%20street%20lights%2C%20paparazzi%20atmosphere%2C%20cinematic%20composition%2C%20subtle%20noir%20vibe%2C%20soft%20shadows%2C%20elegant%20and%20dramatic%20mood&width=800&height=500&seq=article-dingliu-nanxing&orientation=landscape',
    author: '吃瓜小编',
    publishedAt: '2026-08-07T10:30:00Z',
    views: 128350,
    comments: 3421,
    tags: ['顶流', '恋情曝光', '明星八卦', '狗仔爆料'],
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '千万粉丝网红直播翻车，假货被当场拆穿场面尴尬',
    slug: 'qianwan-wanghong-fanche',
    category: 'wanghong-fanche',
    excerpt: '拥有千万粉丝的美妆博主在直播带货时，被专业鉴定师现场打假，直播间瞬间炸锅，场面一度失控。',
    content: `昨晚，拥有超过1200万粉丝的知名美妆博主"小鹿美妆日记"在直播带货时遭遇了职业生涯最大的一次翻车事件。

当时她正在推销一款号称"法国进口、专柜同步"的高端精华液，原价2999元，直播间秒杀价仅需299元。就在她激情澎湃地介绍产品功效时，一位自称持有国际化妆品鉴定师证书的网友连麦上麦，当场指出了产品的多个疑点。

该鉴定师逐一拆解：产品包装上的法语拼写有多处错误、防伪标识与官方公示的不一致、成分表中含有已被欧盟禁用的成分。更尴尬的是，该网友当场展示了与法国品牌方客服的聊天记录，品牌方明确表示从未授权该主播销售此产品。

直播间瞬间炸锅，弹幕刷屏不断。面对质疑，该主播先是沉默了几十秒，随后匆忙表示"需要和团队核实"就匆匆下播。截至发稿前，该主播的账号评论区已被愤怒的粉丝攻陷，大量消费者要求退款维权。

据了解，该场直播的销售额超过了800万元，如果假货坐实，该主播可能面临巨额赔偿甚至刑事责任。`,
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20live%20streaming%20studio%20scene%20with%20beauty%20products%20on%20a%20desk%2C%20ring%20light%20glowing%2C%20chaotic%20atmosphere%20with%20red%20alert%20vibe%2C%20dramatic%20lighting%2C%20professional%20photography%20style&width=800&height=500&seq=article-wanghong-fanche&orientation=landscape',
    author: '吃瓜小编',
    publishedAt: '2026-08-06T20:15:00Z',
    views: 256780,
    comments: 8932,
    tags: ['网红翻车', '直播带货', '假货', '维权'],
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '某女星被爆与已婚导演关系暧昧，剧组工作人员称亲眼所见',
    slug: 'nvxing-dao-yan-aimei',
    category: 'mingxing-bagua',
    excerpt: '一位自称剧组工作人员的网友匿名爆料，某当红女星在拍摄期间与已婚导演互动频繁超出正常工作关系。',
    content: `近日，一位自称在某热播剧剧组工作过的网友在社交平台发布长文，爆料某当红女星与已婚导演在拍摄期间的暧昧关系。

该网友详细描述了多个令人遐想的场景：深夜收工后导演多次单独前往女星房间"讨论剧本"、两人在剧组聚餐时总是默契地坐在一起、导演对女星的特殊照顾远超其他演员。

更劲爆的是，该网友称自己亲眼目睹两人在拍摄某场亲密戏份时，导演亲自上阵示范，两人身体接触的时间明显超过了必要的工作范畴。该场景也让在场的多位工作人员面面相觑。

该爆料一出，立即引发网友热议。有网友迅速扒出该剧组近期的路透照和视频，发现该女星与导演的互动确实异于常人。虽然目前双方均未回应，但此事已经在网上持续发酵。

值得注意的是，该导演的妻子是圈内知名的制片人，两人结婚多年一直被视为娱乐圈模范夫妻。如果爆料属实，这对夫妻的形象将遭受重创。`,
    image: 'https://readdy.ai/api/search-image?query=A%20film%20set%20at%20night%20with%20dramatic%20lighting%2C%20director%20chair%20and%20camera%20equipment%2C%20mysterious%20silhouette%20behind%20a%20curtain%2C%20cinematic%20moody%20atmosphere%2C%20film%20noir%20style%2C%20dark%20warm%20tones&width=800&height=500&seq=article-nvxing-daoyan&orientation=landscape',
    author: '八卦猎人',
    publishedAt: '2026-08-06T14:00:00Z',
    views: 198420,
    comments: 5678,
    tags: ['女星', '导演', '剧组', '暧昧关系'],
    featured: false,
    hot: true,
  },
  {
    id: 4,
    title: '热门综艺选手被曝学历造假，节目组紧急删减镜头',
    slug: 'zongyi-xueli-zaojia',
    category: 'zongyi-baoliao',
    excerpt: '某选秀综艺人气选手被网友扒出学历造假，其号称的海外名校留学经历纯属虚构，节目组已开始紧急处理。',
    content: `随着某热门选秀综艺的热播，一位人气选手的学历背景引起了网友的质疑。该选手在节目中多次表示自己毕业于美国某常春藤名校，这一"学霸"人设也为其赢得了不少粉丝的喜爱。

然而，有较真的网友通过学校官方渠道进行了核实，结果发现该选手所说的专业、入学年份、毕业时间等信息全部对不上。更离谱的是，该学校根本没有这位选手的任何注册记录。

随着质疑声越来越大，越来越多的证据浮出水面。有网友发现该选手此前在社交平台上发布的所谓"校园生活照"实际上是从其他留学生的账号中盗用的，连照片中的教学楼都不是其声称的学校。

面对铺天盖地的质疑，节目组已经开始紧急处理——在最新一期节目中，所有涉及该选手学历介绍的部分都已被删减或重新剪辑。该选手本人则保持沉默，其社交账号也设置了评论限制。

此事引发了关于综艺节目选手背景审核机制的广泛讨论。业内人士指出，类似的学历造假在选秀节目中并不罕见，节目组往往为了制造话题和人设选择性忽视这类问题。`,
    image: 'https://readdy.ai/api/search-image?query=A%20talent%20show%20stage%20with%20dramatic%20spotlight%2C%20a%20single%20microphone%20stand%20in%20the%20center%2C%20empty%20audience%20seats%2C%20controversial%20atmosphere%2C%20dark%20theater%20lighting%2C%20suspenseful%20mood&width=800&height=500&seq=article-zongyi-xueli&orientation=landscape',
    author: '综艺侦探',
    publishedAt: '2026-08-05T16:45:00Z',
    views: 167890,
    comments: 4521,
    tags: ['综艺', '学历造假', '选秀', '人设崩塌'],
    featured: false,
    hot: false,
  },
  {
    id: 5,
    title: '某古装剧剧组被曝拖欠群演工资，上百人集体维权',
    slug: 'guzhuangju-tuoqian-gongzi',
    category: 'yingshiquan',
    excerpt: '正在横店热拍的某S级古装大剧被爆拖欠群演工资长达三个月，上百名群众演员联合发起维权行动。',
    content: `正在横店影视城热拍的某S级古装大剧近日陷入了欠薪风波。据多位群演反映，该剧自开拍以来一直存在拖欠工资的问题，目前已有上百名群众演员受到影响。

一位不愿透露姓名的群演告诉记者，该剧从今年5月开拍至今，只发过一次工资，目前已经拖欠了整整三个月的薪资。"每次问剧组财务，都说下周就发，但下周复下周，到现在也没看到一分钱。"

更令人气愤的是，该剧组的几位主演据传片酬高达数千万元，而群演们每天的工资不过两百元左右。"大明星拿几千万，我们两百块的辛苦钱都不给，这合理吗？"

目前，受影响的群演们已经组建了维权群，并收集了相关的证据材料。他们表示，如果剧组在一周内不能结清欠薪，将采取法律手段维权，并考虑向媒体曝光更多内幕。

横店影视城管理方表示已关注到此事，正在与剧组进行沟通协调。业内人士分析，如果此事持续发酵，可能会影响该剧的拍摄进度和后续播出计划。`,
    image: 'https://readdy.ai/api/search-image?query=A%20ancient%20Chinese%20costume%20drama%20film%20set%20with%20extras%20standing%20in%20traditional%20clothing%2C%20protest%20atmosphere%2C%20banners%20and%20signs%2C%20dusty%20backlot%2C%20golden%20hour%20lighting%2C%20documentary%20style&width=800&height=500&seq=article-guzhuangju&orientation=landscape',
    author: '影视圈内人',
    publishedAt: '2026-08-05T09:00:00Z',
    views: 98760,
    comments: 2345,
    tags: ['古装剧', '欠薪', '群演维权', '横店'],
    featured: false,
    hot: false,
  },
  {
    id: 6,
    title: '当红小生私下素质堪忧？餐厅服务员爆料其傲慢无礼行为',
    slug: 'danghong-xiaosheng-suzhi',
    category: 'mingxing-bagua',
    excerpt: '某高档餐厅服务员在社交平台发帖吐槽，某当红小生在用餐时态度傲慢、对服务员颐指气使，引发网友热议。',
    content: `近日，一位自称在北京某高档餐厅工作的服务员在社交平台发表了一篇长文，详细描述了某当红小生在餐厅用餐时的种种不当行为，引发了网友的广泛讨论。

据该服务员描述，这位小生当天带着助理和朋友一行五人前来用餐。从进门开始就表现出极大的傲慢——拒绝在普通餐位就座，强行要求使用已经预订出去的包间；用餐过程中多次对服务员呼来喝去，语气极其不耐烦；因为一道菜的摆盘不符合他的审美，直接摔了筷子要求重做。

"他说'你知道我是谁吗'的时候，那种居高临下的眼神，真的让人很不舒服。"服务员在帖文中写道。

最令人气愤的是，结账时该小生让助理与服务员争执账单，要求免去服务费和几道"不满意"的菜品费用，最终餐厅经理为了息事宁人选择了妥协。

该帖文发出后迅速登上热搜，不少网友表示"又是一个表里不一的明星"。也有自称圈内人士的网友评论称，该小生在圈内口碑确实不好，"耍大牌"是出了名的。目前该小生及其团队尚未对此事作出回应。`,
    image: 'https://readdy.ai/api/search-image?query=An%20upscale%20Chinese%20restaurant%20private%20dining%20room%20with%20luxurious%20decoration%2C%20empty%20table%20with%20fine%20dining%20setup%2C%20tense%20atmosphere%2C%20warm%20dim%20lighting%2C%20elegant%20but%20cold%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-xiaosheng-suzhi&orientation=landscape',
    author: '吃瓜小编',
    publishedAt: '2026-08-04T18:30:00Z',
    views: 215430,
    comments: 7823,
    tags: ['当红小生', '耍大牌', '素质', '餐厅爆料'],
    featured: true,
    hot: true,
  },
  {
    id: 7,
    title: '某知名网红偷税被罚数千万，工作室连夜发道歉声明',
    slug: 'zhiming-wanghong-toushui',
    category: 'wanghong-fanche',
    excerpt: '继多位明星之后，又一位头部网红因偷逃税款被税务部门查处，罚款金额高达数千万元。',
    content: `税务部门近日公布了一起网红偷逃税案件，涉案金额之大令人瞠目。据悉，某在全网拥有超过5000万粉丝的头部网红，通过虚假申报、隐匿收入等方式偷逃个人所得税及增值税，被税务部门依法查处。

经查，该网红在2023年至2025年期间，通过设立多家空壳公司、拆分合同收入、虚列成本费用等手段，隐匿直播打赏收入和广告代言收入共计超过8000万元，少缴税款约3000万元。

税务部门依据相关法律法规，对该网红追缴税款、加收滞纳金并处罚款，合计超过6000万元。目前该网红已按规定缴清了全部款项。

事发后，该网红工作室连夜发布了道歉声明，承认在税务管理方面存在疏忽，并表示接受处罚、深刻反思。但网友们并不买账，评论区一片"凉凉"的刷屏声。

业内人士分析，随着税务监管的日益严格，未来会有更多网红的税务问题被曝光。这也给整个行业敲响了警钟——无论粉丝多少，依法纳税是每个公民的基本义务。`,
    image: 'https://readdy.ai/api/search-image?query=A%20luxurious%20modern%20office%20with%20a%20large%20empty%20desk%2C%20financial%20documents%20scattered%2C%20a%20red%20warning%20stamp%20visible%2C%20cold%20corporate%20atmosphere%2C%20serious%20business%20photography%20style&width=800&height=500&seq=article-wanghong-toushui&orientation=landscape',
    author: '税务观察员',
    publishedAt: '2026-08-04T11:00:00Z',
    views: 342100,
    comments: 12567,
    tags: ['网红', '偷税', '罚款', '行业整顿'],
    featured: true,
    hot: true,
  },
  {
    id: 8,
    title: '某综艺节目录制现场发生冲突，两位嘉宾大打出手',
    slug: 'zongyi-luzhi-chongtu',
    category: 'zongyi-baoliao',
    excerpt: '据现场观众爆料，某热门综艺在最新一期录制中，两位嘉宾因游戏环节发生口角最终演变为肢体冲突。',
    content: `据参与了某热门综艺最新一期录制的现场观众爆料，当天录制过程中发生了一起严重的冲突事件，导致录制中断了近两个小时。

据悉，冲突的起因是节目中的一个竞技游戏环节。两位嘉宾——一位是资深演员，另一位是新生代偶像——因为对游戏规则的理解产生了分歧。起初只是言语上的争执，但随着双方情绪逐渐激动，争执升级为了互相推搡。

现场观众描述，两人从台上吵到台下，期间摔了道具、踢翻了椅子，场面一度十分混乱。节目组工作人员和其他嘉宾费了好大劲才将两人分开。资深演员被助理带走后，新生代偶像还在后台大喊"我不录了"。

最终在导演组的协调下，两人勉强完成了后续录制，但整场气氛已经降到了冰点。据说节目组正在考虑是否要将这段冲突剪辑进正片——如果剪进去，收视率肯定爆表；但如果因此得罪了嘉宾，后续合作可能会受影响。

此事在网络上引发了关于娱乐圈"前辈文化"和"偶像特权"的激烈讨论。`,
    image: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20set%20with%20overturned%20chairs%20and%20scattered%20props%2C%20dramatic%20stage%20lighting%2C%20chaotic%20scene%2C%20two%20spotlights%20facing%20each%20other%2C%20tense%20confrontational%20atmosphere%2C%20behind%20the%20scenes%20style&width=800&height=500&seq=article-zongyi-chongtu&orientation=landscape',
    author: '综艺侦探',
    publishedAt: '2026-08-03T21:00:00Z',
    views: 287650,
    comments: 9876,
    tags: ['综艺', '冲突', '录制事故', '嘉宾'],
    featured: false,
    hot: true,
  },
  {
    id: 9,
    title: '某导演新片票房惨败，被爆拍摄期间多次修改剧本致预算超支',
    slug: 'daoyan-piaofang-canbai',
    category: 'yingshiquan',
    excerpt: '知名导演的最新力作上映首周票房不足预期十分之一，知情人爆料拍摄期间的混乱管理是主因。',
    content: `某曾获得国际大奖的知名导演，其最新力作上映首周票房惨淡，仅收获约3000万元，还不到片方预期的十分之一。随着影片口碑与票房双双崩塌，越来越多的幕后故事被曝光。

据一位参与该片制作的工作人员透露，影片拍摄期间可以用"灾难"来形容。该导演在拍摄过程中反复修改剧本，有时甚至在拍摄当天临时推翻之前的方案，导致大量已搭建的场景和道具白白浪费。

"光是剧本就改了十几版，每一版都和上一版天差地别。"该工作人员表示，"因为频繁修改，拍摄周期从原定的3个月延长到了7个月，预算也从8000万飙升到了2.2亿。"

更令人费解的是，该导演在后期剪辑阶段又将大量已拍摄的素材弃之不用，重新补拍了很多场景。多位演员因为档期问题无法配合补拍，最终不得不修改角色设定甚至删减角色戏份。

有影评人尖锐地指出，该片的问题在于导演过于自我——完全不顾市场和观众的接受度，把一部商业片拍成了个人实验作品。而这种"艺术家任性"的背后，是投资方数亿元的巨额亏损。`,
    image: 'https://readdy.ai/api/search-image?query=An%20empty%20movie%20theater%20with%20red%20seats%2C%20a%20dim%20screen%20showing%20credits%2C%20melancholy%20atmosphere%2C%20abandoned%20popcorn%20bucket%2C%20cinematic%20lighting%2C%20sad%20and%20empty%20mood&width=800&height=500&seq=article-daoyan-piaofang&orientation=landscape',
    author: '影视圈内人',
    publishedAt: '2026-08-03T15:30:00Z',
    views: 145320,
    comments: 3456,
    tags: ['导演', '票房惨败', '预算超支', '电影'],
    featured: false,
    hot: false,
  },
  {
    id: 10,
    title: '某女团成员被爆霸凌队友，聊天记录曝光后引发粉丝大战',
    slug: 'nvtuan-baling-duiyou',
    category: 'mingxing-bagua',
    excerpt: '一组疑似某当红女团内部聊天记录在网上疯传，内容显示某成员长期对队友进行言语霸凌和排挤。',
    content: `一组疑似某当红女团内部群聊的聊天记录截图在网络上疯传，内容令人震惊。根据截图显示，该女团某核心成员在私下聊天中多次使用侮辱性语言评价其他队友，并密谋排挤团内的一位人气成员。

聊天记录中，该成员用"土包子"、"拖后腿的"等词汇形容某位队友，还抱怨该队友"抢了她的C位"和"资源"。更过分的是，她还在群里鼓动其他成员在该队友生日当天集体"忘记"送祝福，营造孤立氛围。

这组聊天记录的来源尚不明确，但内容之详细、语气之真实，让大量网友相信这确实是内部泄露。消息一出，各成员的粉丝团立刻陷入混战——被霸凌成员的粉丝要求公司严肃处理，而涉事成员的粉丝则坚称截图是伪造的。

女团所属经纪公司发表声明称"正在核实聊天记录的真实性"，并表示"将依法追究恶意造谣者的法律责任"。但这一模棱两可的回应反而引发了更多猜测。

有业内人士透露，该团内部关系确实不太和谐，公司一直在努力调解但效果不佳。此次事件无论真假，都可能成为该团解散的导火索。`,
    image: 'https://readdy.ai/api/search-image?query=A%20K-pop%20style%20girl%20group%20dressing%20room%20backstage%2C%20mirrors%20with%20lights%2C%20one%20chair%20isolated%20in%20the%20corner%2C%20cold%20tension%20atmosphere%2C%20makeup%20scattered%2C%20dramatic%20lighting&width=800&height=500&seq=article-nvtuan-baling&orientation=landscape',
    author: '吃瓜小编',
    publishedAt: '2026-08-02T19:00:00Z',
    views: 412300,
    comments: 18765,
    tags: ['女团', '霸凌', '聊天记录', '粉丝大战'],
    featured: true,
    hot: true,
  },
  {
    id: 11,
    title: '网红带货保健品被曝无备案，消费者食用后出现不良反应',
    slug: 'wanghong-baojianpin-wubeian',
    category: 'wanghong-fanche',
    excerpt: '一位拥有百万粉丝的健身网红推荐的"独家配方"保健品被曝光无生产备案，多名消费者反映食用后身体不适。',
    content: `一位拥有超过300万粉丝的健身网红近期陷入了严重的信任危机——其大力推荐的"独家配方"保健品被曝光没有任何生产备案，属于"三无产品"。

该网红此前在直播中声称这款保健品是其"与日本顶级实验室合作研发"的，含有"独家专利成分"，能够"一周见效、一个月蜕变"。每盒售价高达498元，据其公布的数据，累计销量已超过20万盒。

然而，经过调查发现，该产品包装上的生产许可证编号在国家药品监督管理局数据库中查询不到任何信息。所谓的"日本合作实验室"也查无此地。实际上，这款产品很可能是在某个地下作坊灌装的普通蛋白粉。

更严重的是，已有多名消费者在社交平台反映食用该产品后出现了腹泻、皮疹、头晕等不良反应。有消费者表示，在联系客服要求退款时被拉黑，维权无门。

目前，市场监管部门已经介入调查。该网红的社交账号虽然还在更新，但评论区已经全面沦陷。法律人士指出，如果查实该产品存在质量安全问题，该网红可能面临刑事责任。`,
    image: 'https://readdy.ai/api/search-image?query=A%20gym%20supplement%20display%20with%20protein%20powder%20jars%2C%20warning%20signs%20and%20red%20tape%20across%20products%2C%20laboratory%20testing%20scene%2C%20clinical%20white%20lighting%2C%20investigative%20journalism%20style&width=800&height=500&seq=article-baojianpin-wubeian&orientation=landscape',
    author: '消费维权记者',
    publishedAt: '2026-08-02T14:00:00Z',
    views: 198760,
    comments: 6543,
    tags: ['网红', '保健品', '三无产品', '消费者维权'],
    featured: false,
    hot: true,
  },
  {
    id: 12,
    title: '某综艺常驻嘉宾被换，疑似因片酬问题与节目组闹翻',
    slug: 'zongyi-jiabin-beihuan',
    category: 'zongyi-baoliao',
    excerpt: '已录制多季的某综艺节目突然宣布更换常驻嘉宾，知情人士透露是因该嘉宾提出天价片酬要求被拒。',
    content: `已经连续参与了四季录制的某热门综艺节目突然通过官方账号宣布，新一季将更换一位常驻嘉宾。这一消息让众多忠实观众感到意外和不解。

据知情人士透露，换人的真实原因是该嘉宾在续约谈判中提出了一个"天价"片酬要求——单季片酬从之前的800万直接跳涨到3000万，几乎翻了四倍。该嘉宾的理由是自己最近几部作品大热，人气和商业价值大幅提升，片酬应当相应调整。

然而，节目组认为，该综艺本身才是嘉宾人气提升的主要原因——是该节目给了嘉宾展示真实性格和才华的舞台，而不是反过来。因此节目组拒绝了天价片酬要求，双方谈判破裂。

最终，节目组决定启用一位年轻新人替代该嘉宾。这一决定的背后也有商业考量——新人的片酬不到原嘉宾的十分之一，而且可塑性强，能够为节目带来新鲜感。

不过，也有业内人士提出不同看法：综艺节目频繁更换常驻嘉宾会影响观众的观看惯性和情感连接，长远来看对节目口碑不利。`,
    image: 'https://readdy.ai/api/search-image?query=A%20variety%20show%20panel%20with%20five%20chairs%2C%20one%20chair%20empty%20and%20pushed%20aside%2C%20bright%20studio%20lights%2C%20replacement%20and%20change%20theme%2C%20television%20production%20setting&width=800&height=500&seq=article-zongyi-jiabin&orientation=landscape',
    author: '综艺侦探',
    publishedAt: '2026-08-01T16:00:00Z',
    views: 176540,
    comments: 5432,
    tags: ['综艺', '嘉宾更换', '片酬', '节目组'],
    featured: false,
    hot: false,
  },
];

export const hotTopics = [
  { id: 1, title: '某顶流男星恋情曝光', count: 128350 },
  { id: 2, title: '千万网红直播翻车', count: 256780 },
  { id: 3, title: '女星与已婚导演暧昧', count: 198420 },
  { id: 4, title: '女团成员霸凌队友', count: 412300 },
  { id: 5, title: '网红偷税被罚数千万', count: 342100 },
  { id: 6, title: '当红小生餐厅耍大牌', count: 215430 },
  { id: 7, title: '综艺嘉宾大打出手', count: 287650 },
  { id: 8, title: '网红保健品无备案', count: 198760 },
];